<template>
  <div id="import">
    <CCard class="form-import">
      <CRow class="form-header">{{ $t(`timeSheets.import_file`) }}</CRow>
      <CRow
        class="form-body"
        @dragstart="onDragEnter"
        @dragleave="onDragLeave"
        @dragover.prevent
        @drop="onDrop"
      >
        <CIcon
          name="cil-cloud-upload"
          height="50px"
          style="display:block; margin:10px auto  "
        />
        <div>Drag and drop your file here</div>
        <div>or</div>
        <CButton
          color="primary"
          size="sm"
          class="m-2"
          @click="$refs.importFile.click()"
          >Select a file</CButton
        >
        <input
          type="file"
          ref="importFile"
          @change="chooseFile"
          accept=".xls, .xlsx, .csv"
        />
        <div class="list-file">
          <div class="file-item" v-for="(file, index) in files" :key="index">
            {{ file.name }}
            <span @click="deleteFile(index)">
              <CIcon name="cilMinus" class="delete-file" />
            </span>
          </div>
        </div>
      </CRow>
      <CRow class="form-footer">
        <CButton
          color="primary"
          size="sm"
          @click="submit"
          :disabled="dataTable.length > 0 ? false : true"
        >
          {{ $t("employee.import") }}
        </CButton>
      </CRow>
    </CCard>
    <CCardBody>
      <div v-if="dataTable.length > 0" class="table-wrapper">
        <CDataTable
          :items="dataTable"
          :fields="header"
          column-filter
          items-per-page-select
          :items-per-page="20"
          hover
          sorter
          pagination
        ></CDataTable>
      </div>
    </CCardBody>
  </div>
</template>

<script>
const fileType = [
  "application/vnd.ms-excel",
  "application/msexcel",
  "application/x-msexcel",
  "application/x-ms-excel",
  "application/x-excel",
  "application/x-dos_ms_excel",
  "application/xls",
  "application/xml",
  "application/x-xls",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
];
let countSuccessFile = 0;
const fileSize = 10485760;
import XLSX from "xlsx";
import i18n from "../../plugins/i18n";
import { mapActions } from "vuex";
export default {
  name: "ImportDaysOff",
  metaInfo() {
    return {
      title: this.$t("page_title.page_additional_days_off"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  data() {
    return {
      files: [],
      fileNames: [],
      dataTable: [],
      header: ["Mã nhân viên", "Họ và tên", "Số ngày phép thay đổi"]
    };
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),
    chooseFile(e) {
      if (this.files.length === 1) {
        this.$toast(
          i18n.t("importExcel.unique"),
          "Error",
          1000,
          "b-toaster-top-center",
          "danger"
        );
        this.$refs.importFile.value = "";
        return;
      }
      let file = e.target.files[0];
      this.checkInputFile(file);
      if (countSuccessFile) {
        this.$toast(
          i18n.t("importExcel.success"),
          "Success",
          1000,
          "b-toaster-top-center",
          "success"
        );
      }
      this.$refs.importFile.value = "";
      countSuccessFile = 0;
      this.preview();
    },
    // eslint-disable-next-line no-unused-vars
    onDragEnter(e) {
      // e.preventDefault();
    },
    // eslint-disable-next-line no-unused-vars
    onDragLeave(e) {
      // e.preventDefault();
    },
    onDrop(e) {
      e.preventDefault();
      e.stopPropagation();
      let files = e.dataTransfer.files;
      if (files.length > 1 || this.files.length === 1) {
        this.$toast(
          i18n.t("importExcel.unique"),
          "Error",
          1000,
          "b-toaster-top-center",
          "danger"
        );
        return;
      }
      if (fileType.includes(files[0].type)) {
        this.checkInputFile(files[0]);
      } else {
        this.$toast(
          i18n.t("importExcel.extention"),
          "Error",
          1000,
          "b-toaster-top-center",
          "danger"
        );
      }
      if (countSuccessFile) {
        this.$toast(
          i18n.t("importExcel.success"),
          "Success",
          1000,
          "b-toaster-top-center",
          "success"
        );
         this.preview();
      }
      countSuccessFile = 0;
      // this.preview();
    },
    checkInputFile(file) {
      if (file.size <= fileSize) {
        countSuccessFile++;
        this.files.push(file);
        this.fileNames.push(file.name);
      } else {
        this.$toast(
          i18n.t("importExcel.oversize"),
          "Error",
          1000,
          "b-toaster-top-center",
          "danger"
        );
      }
    },
    deleteFile(index) {
      this.files.splice(index, 1);
      this.fileNames.splice(index, 1);
      this.dataTable = [];
      this.header = [];
    },
    async preview() {
      if (this.files.length < 1) return;
      let file = this.files[0];
      let reader = new FileReader();
      var $this = this;
      reader.onload = function(e) {
        let data = new Uint8Array(e.target.result);
        let workbook = XLSX.read(data, {
          type: "array",
          cellText: false,
          cellDates: true
        });
        let sheetName = workbook.SheetNames[0];

        let worksheet = workbook.Sheets[sheetName];
        var range = XLSX.utils.decode_range(worksheet["!ref"]);

        range.s.r = 0;
        worksheet["!ref"] = XLSX.utils.encode_range(range);
        $this.dataTable = XLSX.utils.sheet_to_json(worksheet
        );
      };
      await reader.readAsArrayBuffer(file);

    },
    submit() {
      this.setLoading(true);
      this.$store
        .dispatch("employee/importNumberOfLeave", {
          import_file: this.dataTable
        })
        .then(() => {
          this.setLoading(false);
          this.$toast(
            this.$t("popup.label_popup_import_success"),
            null,
            2000,
            "b-toaster-top-center",
            "success"
          );
          this.$router.push({ name: 'employees.days-off' });
        })
        .catch(() => {
          this.setLoading(false);
        });
    }
  }
};
</script>

<style lang="scss">
.form-header,
.form-footer {
  margin: 10px 20px;
  button {
    margin-left: auto;
  }
}
.form-body {
  margin: 10px 20px;
  border: 1px dotted gray;
  display: block;
  text-align: center;
  input[type="file"] {
    display: none;
  }
  .list-file {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    min-height: 50px;
    .file-item {
      margin: 10px;
      padding: 5px;
      background: #cecece;
      border-radius: 5px;
      .delete-file {
        color: white;
        position: absolute;
        top: 0;
        background: red;
        border-radius: 50%;
        cursor: pointer;
        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }
}
.table-wrapper {
  max-height: 600px;
  overflow: auto;
  .pagination {
    justify-content: center !important;
  }
}
</style>
